// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-dynamicmed-js": () => import("./../../../src/pages/dynamicmed.js" /* webpackChunkName: "component---src-pages-dynamicmed-js" */),
  "component---src-pages-index-dev-js": () => import("./../../../src/pages/index-dev.js" /* webpackChunkName: "component---src-pages-index-dev-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

